import {ResourceType} from "../types";

export const validFileTypes = new Set<ResourceType>([
    ResourceType.pdf,
    ResourceType.microsoftWord,
    ResourceType.microsoftWordOld,
    ResourceType.microsoftExcel,
    ResourceType.microsoftExcelOld,
    ResourceType.microsoftExcelTemplate,
    ResourceType.microsoftExcelMacroEnabledTemplate,
    ResourceType.microsoftExcelMacroEnabled,
    ResourceType.microsoftPowerpoint,
]);
